import { DeckardFilter, Filter } from '@components/filter/types';
import { useMemo, useState } from 'react';

const isActiveFilter = (filter: Filter<unknown>): boolean => {
  if (filter.type === 'boolean') {
    return filter.value === true;
  }
  return Array.isArray(filter.value) && filter.value.length > 0;
};

export const useSearchDetails = <T,>(filterTemplate: DeckardFilter<T>) => {
  const [filter, setFilter] = useState<DeckardFilter<T>>(filterTemplate);

  const { queryFilter, activeFilters } = useMemo(() => {
    const keys = Object.keys(filter) as (keyof T)[];
    const activeKeys = keys.filter((key) => isActiveFilter(filter[key]));
    const queryFilterObject = activeKeys.reduce((acc, key) => {
      acc[key] = filter[key].value as T[keyof T];
      return acc;
    }, {} as T);
    return { queryFilter: queryFilterObject, activeFilters: activeKeys.length > 0 };
  }, [filter]);

  return { activeFilters, filter, queryFilter, setFilter };
};
